import React from 'react';
import { Route, Switch } from 'react-router';

import UserCreate from './UserCreate';
import UserDetail from './UserDetail';
import UserList from './UserList/UserList';

export default function Users() {
  return (
    <Switch>
      <Route path="/users/create" component={UserCreate} />
      <Route path="/users/:id" component={UserDetail} />
      <Route path="/users" component={UserList} />
    </Switch>
  );
}
